import { Button, Stack } from '@mui/material';
import Typography from '@mui/material/Typography';
import React, { useState } from 'react';
import { ClientCostItem, ModalPricingForm } from './ModalPricingForm';
import { createPricing, deletePricing } from 'services/pricing';
import { TFile } from 'types/user';
import DeleteIcon from '@mui/icons-material/Delete';
import axios from 'axios';
import { useAsyncCallback } from 'hooks/useAsyncCallback';
import ArticleIcon from '@mui/icons-material/Article';
const uploadPricingDocument = async (file: File): Promise<number> => {
  const formData = new FormData();
  formData.append('files', file);

  const { data } = await axios.post('/storages/pricing_documents', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return data.files[0];
};

type PricingFormProps = {
  file: TFile;
  reloadPage: () => Promise<void>;
};
export const PricingForm = ({ file, reloadPage }: PricingFormProps) => {
  const [open, setOpen] = useState<boolean>(false);
  const handleSubmitFormPricing = async (value: { clientCost: ClientCostItem[] }) => {
    if (!file?.id) return;

    const pricingPayload = [];

    for (const item of value.clientCost) {
      let documentId: number | undefined;

      if (item.document) {
        documentId = await uploadPricingDocument(item.document);
      }

      pricingPayload.push({
        amount: Number(item.value),
        note: item.key,
        documentId
      });
    }

    await createPricing(pricingPayload, Number(file.id));

    setOpen(false);
    await reloadPage();
  };

  const { asyncCallback: asyncHandleSubmitFormPricing } = useAsyncCallback(
    handleSubmitFormPricing,
    []
  );
  const handleDeletePricing = async (idPricing: number) => {
    await deletePricing(Number(idPricing));
    reloadPage && reloadPage();
  };

  return (
    <Stack gap={'100%'}>
      <Stack flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'}>
        <Typography fontSize={16} fontWeight={600} color={'#22374A'}>
          Pricing
        </Typography>
        <Button
          onClick={() => setOpen(true)}
          style={{
            padding: '0 10px',
            width: '140px',
            background: '#22374A',
            borderRadius: '10px',
            border: '2px solid #22374A',
            color: '#fff',
            height: '32px',
            fontWeight: '600',
            fontSize: '12px',
            gap: '8px'
          }}>
          <img src={'/icons/icon_add_new.svg'} alt={'icon_delete'} width={'24px'} />
          Add Cost
        </Button>
      </Stack>
      <Stack
        style={{
          height: '200px',
          overflow: 'auto',
          width: '100%',
          borderRadius: '10px',
          border: '1px solid #A9ABAE',
          marginTop: '14px',
          padding: '10px',
          gap: 10
        }}>
        <Stack gap={1} alignItems={'flex-start'}>
          {file?.pricing?.map((item, index) => {
            return (
              <Stack key={index} width={'100%'} direction="row" gap={2} alignItems="center">
                <Stack flex={1} width={'100%'} direction="row" alignItems="center" gap={2}>
                  <Typography
                    style={{ fontSize: '18px', width: '40%', fontWeight: '400', color: '#000' }}>
                    {item.note}
                  </Typography>
                  :
                  <Stack
                    flex={1}
                    gap={'10px'}
                    alignItems={'center'}
                    justifyContent={'space-between'}
                    flexDirection={'row'}>
                    <Typography style={{ fontSize: '18px', fontWeight: '400', color: '#000' }}>
                      ${item.amount}
                    </Typography>
                    {item.document && (
                      <Stack
                        flexDirection={'row'}
                        gap={'4px'}
                        justifyContent={'flex-end'}
                        width={'160px'}>
                        <Typography
                          style={{
                            marginLeft: '16px',
                            fontSize: '14px',
                            color: '#22374A',
                            cursor: 'pointer',
                            textDecoration: 'underline',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                          }}
                          onClick={() => {
                            window.open(item.url, '_blank');
                          }}
                          title={item.document.fileName}>
                          {item.document.fileName}
                        </Typography>
                        <ArticleIcon />
                      </Stack>
                    )}
                  </Stack>
                </Stack>
                <DeleteIcon
                  style={{ cursor: 'pointer' }}
                  onClick={async () => {
                    if (
                      window.confirm(
                        `Are you sure you want to delete: ${item.note} - $${item.amount}?`
                      )
                    ) {
                      await handleDeletePricing(Number(item.id));
                    }
                  }}
                />
              </Stack>
            );
          })}
        </Stack>
        <ModalPricingForm onSubmit={asyncHandleSubmitFormPricing} isOpen={open} setOpen={setOpen} />
      </Stack>
    </Stack>
  );
};
